import { Coordinate } from '../model/coordinate';
import { SeriesMarkerText, OffsetDirection } from '../model/series-markers';
import { SeriesMarkerRendererDataItem } from './series-markers-renderer';

export function drawText(
  ctx: CanvasRenderingContext2D,
  text: SeriesMarkerText,
  item?: SeriesMarkerRendererDataItem,
  underline?: boolean
): void {

  let y: number = 0;
  let x: number = 0;
  let textValue = text.content;

  if (item && item.offset) {

    if (item.offset.direction == OffsetDirection.Up) {
      y = -item.offset.secondMarkerOffset;
    }

    if (item.offset.direction == OffsetDirection.Down) {
      y = +item.offset.secondMarkerOffset
    }

    textValue = item.text1;


    //   x = item.offset.x;
  }

  if (textValue)
    ctx.fillText(textValue, x + text.x, y + text.y);

  if (underline) {
    let l = text.content.length;
    let a = new Array(l);
    a.fill("_", 0, l);
    let t = a.join("");

    ctx.fillText(t, x + text.x, y + text.y + 3);
  }

}

export function hitTestText(
  text: SeriesMarkerText,
  x: Coordinate,
  y: Coordinate
): boolean {
  const halfHeight = text.height / 2;

  return x >= text.x && x <= text.x + text.width &&
    y >= text.y - halfHeight && y <= text.y + halfHeight;
}
